import {Injectable} from '@angular/core';
import {ActivatedRouteSnapshot, BaseRouteReuseStrategy} from '@angular/router';

/**
 * Angular keeps the same page component when only the URL parameters change. The call page must start over when the
 * room changes (new WebRTC connection, new conversation archive): routes with data.recreateOnParamChange are rebuilt
 * whenever their parameters differ. Every other route behaves as with the default strategy.
 */
@Injectable()
export class RecreateOnParamChangeStrategy extends BaseRouteReuseStrategy {
  override shouldReuseRoute(future: ActivatedRouteSnapshot, curr: ActivatedRouteSnapshot): boolean {
    if (!super.shouldReuseRoute(future, curr)) {
      return false;
    }
    if (!future.data['recreateOnParamChange']) {
      return true;
    }
    return JSON.stringify(future.params) === JSON.stringify(curr.params);
  }
}
